import {
  faCommentAltLines,
  faFileCertificate
} from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

import { Duty } from './types';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { FontAwesomeSvgIcon } from 'components/shared';

export default function TooltipContent({ notes = [], qualifications }: Duty) {
  const { t } = useTranslation('common');
  const validNotes = notes.filter(({ text }) => text?.trim());
  const hasNotes = Boolean(validNotes.length);
  const hasQualifications = Boolean(qualifications && qualifications.length);
  // const isNotFromBaseplan = !isFromBasePlan;
  const isNotFromBaseplan = false;
  const hasContent = hasNotes || hasQualifications || isNotFromBaseplan;

  if (hasContent) {
    return (
      <>
        {hasQualifications && (
          <TableRow>
            <TableCell style={{ fontSize: 0 }}>
              <FontAwesomeSvgIcon icon={faFileCertificate} fontSize="small" />
            </TableCell>
            <TableCell>
              <div>
                <strong>{t('qualifications')}</strong>
              </div>
              {qualifications?.map(({ name, id }) => (
                <div key={id}>{name}</div>
              ))}
            </TableCell>
          </TableRow>
        )}
        {hasNotes && (
          <TableRow>
            <TableCell style={{ fontSize: 0 }}>
              <FontAwesomeSvgIcon icon={faCommentAltLines} fontSize="small" />
            </TableCell>
            <TableCell>
              <div>
                <strong>{t('notes')}</strong>
              </div>
              {validNotes.map(({ text, createdOn }, i) => (
                <div key={text + (createdOn || i)}>{text}</div>
              ))}
            </TableCell>
          </TableRow>
        )}
      </>
    );
  }

  return null;
}
